import React from 'react'
import './footer.css'

function Footer() {
  return (
    <footer id='footer'>
      <label class="footer-tag"><small>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        @ 2022 Designed and Developed By Kashod Cagnolatti
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <a class="footer-link" href="https://sites.google.com/view/agnorokdomain/home" target="_blank" rel="noopener noreferrer">
        click here to check out the old site
        </a></small>
      </label>
      
    </footer>
  )
}

export default Footer